<template>
  <v-card
    class="mx-auto"
    style="max-width: 500px; position: relative; z-index: 1200;"
  >
    <v-toolbar
      color="blue darken-3"
      cards
      dark
      flat
    >
      <v-card-title class="text-button font-weight-regular">
        <v-icon class="mr-2">mdi-hand-heart</v-icon>
        Donation Requirements Form
      </v-card-title>
      <v-spacer></v-spacer> 
    <v-btn icon darken-2 @click="$emit('close-dialog')">
        <v-icon>mdi-close</v-icon>
    </v-btn>
    </v-toolbar>
    <v-form
      ref="form"
      v-model="form"
      class="pl-4 pr-4"
    >
        <v-file-input
            label="Upload Organisation Logo"
            prepend-icon="mdi-camera"
            counter
            :show-size="2000"
            variant="filled"
        ></v-file-input>
        <v-text-field
            filled
            v-model="NameOfProject"
            :rules="[rules.project]"
            color="deep-purple"
            label="Name of Project"
            type="text"
        ></v-text-field>
        <v-text-field
            filled
            v-model="email"
            :rules="[rules.email]"
            color="deep-purple"
            label="Email address"
            type="email"
        ></v-text-field>
        <!---->
        <v-text-field
            filled
            v-model="website"
            :rules="[rules.project]"
            color="deep-purple"
            label="Website"
            type="text"
        ></v-text-field>
        <v-autocomplete filled clearable label="Location" :items="countries" dense
            return-object item-text="name">
        </v-autocomplete>
        <v-text-field
            filled
            v-model="email"
            :rules="[rules.email]"
            color="deep-purple"
            label="Donation Link"
            type="link"
        ></v-text-field>
        <v-textarea
            filled
            label="Description"
            v-model="description"
            background-color="yellow lighten-4"
        ></v-textarea>
        <v-checkbox
            v-model="agreementDialog"
            :rules="[rules.required]"
            color="deep-purple"
        >
        <template v-slot:label>
            I agree to the&nbsp;
            <a
            href="#"
            @click.stop.prevent="dialogAgreement = true"
            >Terms of Service</a>
            &nbsp;and&nbsp;
            <a
            href="#"
            @click.stop.prevent="dialogAgreement = true"
            >Privacy Policy</a>
        </template>
        </v-checkbox>
    </v-form>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        text
        @click="$refs.form.reset()"
      >
        Clear
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="!form"
        :loading="isLoading"
        class="white--text"
        color="deep-purple accent-4"
        depressed
      >
        Submit
      </v-btn>
    </v-card-actions>
    <v-dialog
        v-model="dialogAgreement"
        absolute
        max-width="400"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-3">
          Legal
        </v-card-title>
        <v-card-text>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            text
            @click="agreement = false, dialog = false"
          >
            No
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            color="deep-purple accent-4"
            @click="agreement = true, dialog = false"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { mapMutations } from 'vuex'
import countries from '../countries'
  export default {
    data: () => ({
      agreement: false,
      openDonationDialog: false,
      description: 'Describe to your donors the importance of your venture.',
      dialogAgreement: false,
      email: undefined,
      form: false,
      isLoading: false,
      project: undefined,
      phone: undefined,
      countries: [],
      rules: {
        email: v => !!(v || '').match(/@/) || 'Please enter a valid email',
        //length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
        project: v => !!v || 'This field is required',
        required: v => !!v || 'This field is required',
      },
    }),
    methods: {
      ...mapMutations(['setDialog']),
      closeDialog() {
          this.setDialog(false)
      },
      postPingHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 180;
        case 'sm': return 180;
        case 'md': return 380;
        case 'lg': return 380;
        case 'xl': return 380;
        default: return 380; // Default value if no match
      }
    },
    postPingWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '100%';
        case 'sm': return '100%';
        case 'md': return 480;
        case 'lg': return 480;
        case 'xl': return 480;
        default: return 480; // Default value if no match
      }
    }
    },   
    mounted() {
       this.countries = countries
    },
  }
</script>